export const apiUrl = process.env.REACT_APP_BASE_URL;
export const defaultPagePath = process.env.REACT_APP_DEFAULT_IMG_PATH || "/profilePictures/profile-icon-png-898.png"

export const countriesList = [
  { countryName: "Afghanistan", countryCode: "AF", phoneNumberCode: "+93" },
  { countryName: "Albania", countryCode: "AL", phoneNumberCode: "+355" },
  { countryName: "Algeria", countryCode: "DZ", phoneNumberCode: "+213" },
  { countryName: "Andorra", countryCode: "AD", phoneNumberCode: "+376" },
  { countryName: "Angola", countryCode: "AO", phoneNumberCode: "+244" },
  {
    countryName: "Antigua and Barbuda",
    countryCode: "AG",
    phoneNumberCode: "+1268",
  },
  { countryName: "Argentina", countryCode: "AR", phoneNumberCode: "+54" },
  { countryName: "Armenia", countryCode: "AM", phoneNumberCode: "+374" },
  { countryName: "Australia", countryCode: "AU", phoneNumberCode: "+61" },
  { countryName: "Austria", countryCode: "AT", phoneNumberCode: "+43" },
  { countryName: "Azerbaijan", countryCode: "AZ", phoneNumberCode: "+994" },
  { countryName: "Bahamas", countryCode: "BS", phoneNumberCode: "+1242" },
  { countryName: "Bahrain", countryCode: "BH", phoneNumberCode: "+973" },
  { countryName: "Bangladesh", countryCode: "BD", phoneNumberCode: "+880" },
  { countryName: "Barbados", countryCode: "BB", phoneNumberCode: "+1246" },
  { countryName: "Belarus", countryCode: "BY", phoneNumberCode: "+375" },
  { countryName: "Belgium", countryCode: "BE", phoneNumberCode: "+32" },
  { countryName: "Belize", countryCode: "BZ", phoneNumberCode: "+501" },
  { countryName: "Benin", countryCode: "BJ", phoneNumberCode: "+229" },
  { countryName: "Bhutan", countryCode: "BT", phoneNumberCode: "+975" },
  { countryName: "Bolivia", countryCode: "BO", phoneNumberCode: "+591" },
  {
    countryName: "Bosnia and Herzegovina",
    countryCode: "BA",
    phoneNumberCode: "+387",
  },
  { countryName: "Botswana", countryCode: "BW", phoneNumberCode: "+267" },
  { countryName: "Brazil", countryCode: "BR", phoneNumberCode: "+55" },
  { countryName: "Brunei", countryCode: "BN", phoneNumberCode: "+673" },
  { countryName: "Bulgaria", countryCode: "BG", phoneNumberCode: "+359" },
  { countryName: "Burkina Faso", countryCode: "BF", phoneNumberCode: "+226" },
  { countryName: "Burundi", countryCode: "BI", phoneNumberCode: "+257" },
  { countryName: "Cabo Verde", countryCode: "CV", phoneNumberCode: "+238" },
  { countryName: "Cambodia", countryCode: "KH", phoneNumberCode: "+855" },
  { countryName: "Cameroon", countryCode: "CM", phoneNumberCode: "+237" },
  { countryName: "Canada", countryCode: "CA", phoneNumberCode: "+1" },
  {
    countryName: "Central African Republic",
    countryCode: "CF",
    phoneNumberCode: "+236",
  },
  { countryName: "Chad", countryCode: "TD", phoneNumberCode: "+235" },
  { countryName: "Chile", countryCode: "CL", phoneNumberCode: "+56" },
  { countryName: "China", countryCode: "CN", phoneNumberCode: "+86" },
  { countryName: "Colombia", countryCode: "CO", phoneNumberCode: "+57" },
  { countryName: "Comoros", countryCode: "KM", phoneNumberCode: "+269" },
  {
    countryName: "Congo (Republic of the Congo)",
    countryCode: "CG",
    phoneNumberCode: "+242",
  },
  { countryName: "Costa Rica", countryCode: "CR", phoneNumberCode: "+506" },
  { countryName: "Croatia", countryCode: "HR", phoneNumberCode: "+385" },
  { countryName: "Cuba", countryCode: "CU", phoneNumberCode: "+53" },
  { countryName: "Cyprus", countryCode: "CY", phoneNumberCode: "+357" },
  {
    countryName: "Czechia (Czech Republic)",
    countryCode: "CZ",
    phoneNumberCode: "+420",
  },
  { countryName: "Denmark", countryCode: "DK", phoneNumberCode: "+45" },
  { countryName: "Djibouti", countryCode: "DJ", phoneNumberCode: "+253" },
  { countryName: "Dominica", countryCode: "DM", phoneNumberCode: "+1767" },
  {
    countryName: "Dominican Republic",
    countryCode: "DO",
    phoneNumberCode: "+1",
  },
  { countryName: "Ecuador", countryCode: "EC", phoneNumberCode: "+593" },
  { countryName: "Egypt", countryCode: "EG", phoneNumberCode: "+20" },
  { countryName: "El Salvador", countryCode: "SV", phoneNumberCode: "+503" },
  {
    countryName: "Equatorial Guinea",
    countryCode: "GQ",
    phoneNumberCode: "+240",
  },
  { countryName: "Eritrea", countryCode: "ER", phoneNumberCode: "+291" },
  { countryName: "Estonia", countryCode: "EE", phoneNumberCode: "+372" },
  {
    countryName: "Eswatini (fmr. 'Swaziland')",
    countryCode: "SZ",
    phoneNumberCode: "+268",
  },
  { countryName: "Ethiopia", countryCode: "ET", phoneNumberCode: "+251" },
  { countryName: "Fiji", countryCode: "FJ", phoneNumberCode: "+679" },
  { countryName: "Finland", countryCode: "FI", phoneNumberCode: "+358" },
  { countryName: "France", countryCode: "FR", phoneNumberCode: "+33" },
  { countryName: "Gabon", countryCode: "GA", phoneNumberCode: "+241" },
  { countryName: "Gambia", countryCode: "GM", phoneNumberCode: "+220" },
  { countryName: "Georgia", countryCode: "GE", phoneNumberCode: "+995" },
  { countryName: "Germany", countryCode: "DE", phoneNumberCode: "+49" },
  { countryName: "Ghana", countryCode: "GH", phoneNumberCode: "+233" },
  { countryName: "Greece", countryCode: "GR", phoneNumberCode: "+30" },
  { countryName: "Grenada", countryCode: "GD", phoneNumberCode: "+1" },
  { countryName: "Guatemala", countryCode: "GT", phoneNumberCode: "+502" },
  { countryName: "Guinea", countryCode: "GN", phoneNumberCode: "+224" },
  { countryName: "Guinea-Bissau", countryCode: "GW", phoneNumberCode: "+245" },
  { countryName: "Guyana", countryCode: "GY", phoneNumberCode: "+592" },
  { countryName: "Haiti", countryCode: "HT", phoneNumberCode: "+509" },
  { countryName: "Holy See", countryCode: "VA", phoneNumberCode: "+379" },
  { countryName: "Honduras", countryCode: "HN", phoneNumberCode: "+504" },
  { countryName: "Hungary", countryCode: "HU", phoneNumberCode: "+36" },
  { countryName: "Iceland", countryCode: "IS", phoneNumberCode: "+354" },
  { countryName: "India", countryCode: "IN", phoneNumberCode: "+91" },
  { countryName: "Indonesia", countryCode: "ID", phoneNumberCode: "+62" },
  { countryName: "Iran", countryCode: "IR", phoneNumberCode: "+98" },
  { countryName: "Iraq", countryCode: "IQ", phoneNumberCode: "+964" },
  { countryName: "Ireland", countryCode: "IE", phoneNumberCode: "+353" },
   { countryName: "Italy", countryCode: "IT", phoneNumberCode: "+39" },
  { countryName: "Ivory Coast", countryCode: "CI", phoneNumberCode: "+225" },
  { countryName: "Jamaica", countryCode: "JM", phoneNumberCode: "+1" },
  { countryName: "Japan", countryCode: "JP", phoneNumberCode: "+81" },
  { countryName: "Jordan", countryCode: "JO", phoneNumberCode: "+962" },
  { countryName: "Kazakhstan", countryCode: "KZ", phoneNumberCode: "+7" },
  { countryName: "Kenya", countryCode: "KE", phoneNumberCode: "+254" },
  { countryName: "Kiribati", countryCode: "KI", phoneNumberCode: "+686" },
  { countryName: "Kuwait", countryCode: "KW", phoneNumberCode: "+965" },
  { countryName: "Kyrgyzstan", countryCode: "KG", phoneNumberCode: "+996" },
  { countryName: "Laos", countryCode: "LA", phoneNumberCode: "+856" },
  { countryName: "Latvia", countryCode: "LV", phoneNumberCode: "+371" },
  { countryName: "Lebanon", countryCode: "LB", phoneNumberCode: "+961" },
  { countryName: "Lesotho", countryCode: "LS", phoneNumberCode: "+266" },
  { countryName: "Liberia", countryCode: "LR", phoneNumberCode: "+231" },
  { countryName: "Libya", countryCode: "LY", phoneNumberCode: "+218" },
  { countryName: "Liechtenstein", countryCode: "LI", phoneNumberCode: "+423" },
  { countryName: "Lithuania", countryCode: "LT", phoneNumberCode: "+370" },
  { countryName: "Luxembourg", countryCode: "LU", phoneNumberCode: "+352" },
  { countryName: "Madagascar", countryCode: "MG", phoneNumberCode: "+261" },
  { countryName: "Malawi", countryCode: "MW", phoneNumberCode: "+265" },
  { countryName: "Malaysia", countryCode: "MY", phoneNumberCode: "+60" },
  { countryName: "Maldives", countryCode: "MV", phoneNumberCode: "+960" },
  { countryName: "Mali", countryCode: "ML", phoneNumberCode: "+223" },
  { countryName: "Malta", countryCode: "MT", phoneNumberCode: "+356" },
  {
    countryName: "Marshall Islands",
    countryCode: "MH",
    phoneNumberCode: "+692",
  },
  { countryName: "Mauritania", countryCode: "MR", phoneNumberCode: "+222" },
  { countryName: "Mauritius", countryCode: "MU", phoneNumberCode: "+230" },
  { countryName: "Mexico", countryCode: "MX", phoneNumberCode: "+52" },
  { countryName: "Micronesia", countryCode: "FM", phoneNumberCode: "+691" },
  { countryName: "Moldova", countryCode: "MD", phoneNumberCode: "+373" },
  { countryName: "Monaco", countryCode: "MC", phoneNumberCode: "+377" },
  { countryName: "Mongolia", countryCode: "MN", phoneNumberCode: "+976" },
  { countryName: "Montenegro", countryCode: "ME", phoneNumberCode: "+382" },
  { countryName: "Morocco", countryCode: "MA", phoneNumberCode: "+212" },
  { countryName: "Mozambique", countryCode: "MZ", phoneNumberCode: "+258" },
  {
    countryName: "Myanmar (formerly Burma)",
    countryCode: "MM",
    phoneNumberCode: "+95",
  },
  { countryName: "Namibia", countryCode: "NA", phoneNumberCode: "+264" },
  { countryName: "Nauru", countryCode: "NR", phoneNumberCode: "+674" },
  { countryName: "Nepal", countryCode: "NP", phoneNumberCode: "+977" },
  { countryName: "Netherlands", countryCode: "NL", phoneNumberCode: "+31" },
  { countryName: "New Zealand", countryCode: "NZ", phoneNumberCode: "+64" },
  { countryName: "Nicaragua", countryCode: "NI", phoneNumberCode: "+505" },
  { countryName: "Niger", countryCode: "NE", phoneNumberCode: "+227" },
  { countryName: "Nigeria", countryCode: "NG", phoneNumberCode: "+234" },
  { countryName: "North Korea", countryCode: "KP", phoneNumberCode: "+850" },
  {
    countryName: "North Macedonia",
    countryCode: "MK",
    phoneNumberCode: "+389",
  },
  { countryName: "Norway", countryCode: "NO", phoneNumberCode: "+47" },
  { countryName: "Oman", countryCode: "OM", phoneNumberCode: "+968" },
  { countryName: "Pakistan", countryCode: "PK", phoneNumberCode: "+92" },
  { countryName: "Palau", countryCode: "PW", phoneNumberCode: "+680" },
  {
    countryName: "Palestine State",
    countryCode: "PS",
    phoneNumberCode: "+970",
  },
  { countryName: "Panama", countryCode: "PA", phoneNumberCode: "+507" },
  {
    countryName: "Papua New Guinea",
    countryCode: "PG",
    phoneNumberCode: "+675",
  },
  { countryName: "Paraguay", countryCode: "PY", phoneNumberCode: "+595" },
  { countryName: "Peru", countryCode: "PE", phoneNumberCode: "+51" },
  { countryName: "Philippines", countryCode: "PH", phoneNumberCode: "+63" },
  { countryName: "Poland", countryCode: "PL", phoneNumberCode: "+48" },
  { countryName: "Portugal", countryCode: "PT", phoneNumberCode: "+351" },
  { countryName: "Qatar", countryCode: "QA", phoneNumberCode: "+974" },
  { countryName: "Romania", countryCode: "RO", phoneNumberCode: "+40" },
  { countryName: "Russia", countryCode: "RU", phoneNumberCode: "+7" },
  { countryName: "Rwanda", countryCode: "RW", phoneNumberCode: "+250" },
  {
    countryName: "Saint Kitts and Nevis",
    countryCode: "KN",
    phoneNumberCode: "+1",
  },
  { countryName: "Saint Lucia", countryCode: "LC", phoneNumberCode: "+1" },
  {
    countryName: "Saint Vincent and the Grenadines",
    countryCode: "VC",
    phoneNumberCode: "+1",
  },
  { countryName: "Samoa", countryCode: "WS", phoneNumberCode: "+685" },
  { countryName: "San Marino", countryCode: "SM", phoneNumberCode: "+378" },
  {
    countryName: "Sao Tome and Principe",
    countryCode: "ST",
    phoneNumberCode: "+239",
  },
  { countryName: "Saudi Arabia", countryCode: "SA", phoneNumberCode: "+966" },
  { countryName: "Senegal", countryCode: "SN", phoneNumberCode: "+221" },
  { countryName: "Serbia", countryCode: "RS", phoneNumberCode: "+381" },
  { countryName: "Seychelles", countryCode: "SC", phoneNumberCode: "+248" },
  { countryName: "Sierra Leone", countryCode: "SL", phoneNumberCode: "+232" },
  { countryName: "Singapore", countryCode: "SG", phoneNumberCode: "+65" },
  { countryName: "Slovakia", countryCode: "SK", phoneNumberCode: "+421" },
  { countryName: "Slovenia", countryCode: "SI", phoneNumberCode: "+386" },
  {
    countryName: "Solomon Islands",
    countryCode: "SB",
    phoneNumberCode: "+677",
  },
  { countryName: "Somalia", countryCode: "SO", phoneNumberCode: "+252" },
  { countryName: "South Africa", countryCode: "ZA", phoneNumberCode: "+27" },
  { countryName: "South Korea", countryCode: "KR", phoneNumberCode: "+82" },
  { countryName: "South Sudan", countryCode: "SS", phoneNumberCode: "+211" },
  { countryName: "Spain", countryCode: "ES", phoneNumberCode: "+34" },
  { countryName: "Sri Lanka", countryCode: "LK", phoneNumberCode: "+94" },
  { countryName: "Sudan", countryCode: "SD", phoneNumberCode: "+249" },
  { countryName: "Suriname", countryCode: "SR", phoneNumberCode: "+597" },
  { countryName: "Sweden", countryCode: "SE", phoneNumberCode: "+46" },
  { countryName: "Switzerland", countryCode: "CH", phoneNumberCode: "+41" },
  { countryName: "Syria", countryCode: "SY", phoneNumberCode: "+963" },
  { countryName: "Tajikistan", countryCode: "TJ", phoneNumberCode: "+992" },
  { countryName: "Tanzania", countryCode: "TZ", phoneNumberCode: "+255" },
  { countryName: "Thailand", countryCode: "TH", phoneNumberCode: "+66" },
  { countryName: "Timor-Leste", countryCode: "TL", phoneNumberCode: "+670" },
  { countryName: "Togo", countryCode: "TG", phoneNumberCode: "+228" },
  { countryName: "Tonga", countryCode: "TO", phoneNumberCode: "+676" },
  {
    countryName: "Trinidad and Tobago",
    countryCode: "TT",
    phoneNumberCode: "+1",
  },
  { countryName: "Tunisia", countryCode: "TN", phoneNumberCode: "+216" },
  { countryName: "Turkey", countryCode: "TR", phoneNumberCode: "+90" },
  { countryName: "Turkmenistan", countryCode: "TM", phoneNumberCode: "+993" },
  { countryName: "Tuvalu", countryCode: "TV", phoneNumberCode: "+688" },
  { countryName: "Uganda", countryCode: "UG", phoneNumberCode: "+256" },
  { countryName: "Ukraine", countryCode: "UA", phoneNumberCode: "+380" },
  {
    countryName: "United Arab Emirates",
    countryCode: "AE",
    phoneNumberCode: "+971",
  },
  { countryName: "United Kingdom", countryCode: "GB", phoneNumberCode: "+44" },
  { countryName: "United States", countryCode: "US", phoneNumberCode: "+1" },
  { countryName: "Uruguay", countryCode: "UY", phoneNumberCode: "+598" },
  { countryName: "Uzbekistan", countryCode: "UZ", phoneNumberCode: "+998" },
  { countryName: "Vanuatu", countryCode: "VU", phoneNumberCode: "+678" },
  { countryName: "Vatican City", countryCode: "VA", phoneNumberCode: "+379" },
  { countryName: "Venezuela", countryCode: "VE", phoneNumberCode: "+58" },
  { countryName: "Vietnam", countryCode: "VN", phoneNumberCode: "+84" },
  { countryName: "Yemen", countryCode: "YE", phoneNumberCode: "+967" },
  { countryName: "Zambia", countryCode: "ZM", phoneNumberCode: "+260" },
  { countryName: "Zimbabwe", countryCode: "ZW", phoneNumberCode: "+263" },
];

export const USStates = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
];

export const timeZones = [
  { offset: -12, name: "Etc/GMT-12" },
  { offset: -11, name: "Etc/GMT-11" },
  { offset: -11, name: "Pacific/Midway" },
  { offset: -10, name: "America/Adak" },
  { offset: -9, name: "America/Anchorage" },
  { offset: -9, name: "Pacific/Gambier" },
  { offset: -8, name: "America/Dawson Creek" },
  { offset: -8, name: "America/Ensenada" },
  { offset: -8, name: "America/Los Angeles" },
  { offset: -7, name: "America/Chihuahua" },
  { offset: -7, name: "America/Denver" },
  { offset: -6, name: "America/Belize" },
  { offset: -6, name: "America/Cancun" },
  { offset: -6, name: "America/Chicago" },
  { offset: -6, name: "Chile/EasterIsland" },
  { offset: -5, name: "America/Bogota" },
  { offset: -5, name: "America/Havana" },
  { offset: -5, name: "America/New York" },
  { offset: -4, name: "America/Caracas" },
  { offset: -4, name: "America/Campo Grande" },
  { offset: -4, name: "America/Glace Bay" },
  { offset: -4, name: "America/Goose Bay" },
  { offset: -4, name: "America/Santiago" },
  { offset: -4, name: "America/La Paz" },
  { offset: -3, name: "America/Argentina/Buenos Aires" },
  { offset: -3, name: "America/Montevideo" },
  { offset: -3, name: "America/Araguaina" },
  { offset: -3, name: "America/Godthab" },
  { offset: -3, name: "America/Miquelon" },
  { offset: -3, name: "America/Sao Paulo" },
  { offset: -3, name: "America/St Johns" },
  { offset: -2, name: "America/Noronha" },
  { offset: -1, name: "Atlantic/Cape Verde" },
  { offset: 0, name: "Europe/Belfast" },
  { offset: 0, name: "Africa/Abidjan" },
  { offset: 0, name: "Europe/Dublin" },
  { offset: 0, name: "Europe/Lisbon" },
  { offset: 0, name: "Europe/London" },
  { offset: 0, name: "UTC" },
  { offset: 1, name: "Africa/Algiers" },
  { offset: 1, name: "Africa/Windhoek" },
  { offset: 1, name: "Atlantic/Azores" },
  { offset: 1, name: "Atlantic/Stanley" },
  { offset: 1, name: "Europe/Amsterdam" },
  { offset: 1, name: "Europe/Belgrade" },
  { offset: 1, name: "Europe/Brussels" },
  { offset: 2, name: "Africa/Cairo" },
  { offset: 2, name: "Africa/Blantyre" },
  { offset: 2, name: "Asia/Beirut" },
  { offset: 2, name: "Asia/Damascus" },
  { offset: 2, name: "Asia/Gaza" },
  { offset: 2, name: "Asia/Jerusalem" },
  { offset: 3, name: "Africa/Addis Ababa" },
  { offset: 3, name: "Asia/Riyadh89" },
  { offset: 3, name: "Europe/Minsk" },
  { offset: 3, name: "Asia/Tehran" },
  { offset: 4, name: "Asia/Dubai" },
  { offset: 4, name: "Europe/Moscow" },
  { offset: 4, name: "Asia/Kabul" },
  { offset: 5, name: "Asia/Tashkent" },
  { offset: 5, name: "Asia/Kolkata" },
  { offset: 5, name: "Asia/Katmandu" },
  { offset: 6, name: "Asia/Dhaka" },
  { offset: 6, name: "Asia/Yekaterinburg" },
  { offset: 6, name: "Asia/Rangoon" },
  { offset: 7, name: "Asia/Bangkok" },
  { offset: 7, name: "Asia/Novosibirsk" },
  { offset: 8, name: "Etc/GMT+8" },
  { offset: 8, name: "Asia/Hong Kong" },
  { offset: 8, name: "Asia/Krasnoyarsk" },
  { offset: 8, name: "Australia/Perth" },
  { offset: 8, name: "Australia/Eucla" },
  { offset: 9, name: "Asia/Irkutsk" },
  { offset: 9, name: "Asia/Seoul" },
  { offset: 9, name: "Asia/Tokyo" },
  { offset: 9, name: "Australia/Adelaide" },
  { offset: 9, name: "Australia/Darwin" },
  { offset: 9, name: "Pacific/Marquesas" },
  { offset: 10, name: "Etc/GMT+10" },
  { offset: 10, name: "Australia/Brisbane" },
  { offset: 10, name: "Australia/Hobart" },
  { offset: 10, name: "Asia/Yakutsk" },
  { offset: 10, name: "Australia/Lord Howe" },
  { offset: 11, name: "Asia/Vladivostok" },
  { offset: 11, name: "Pacific/Norfolk" },
  { offset: 12, name: "Etc/GMT+12" },
  { offset: 12, name: "Asia/Anadyr" },
  { offset: 12, name: "Asia/Magadan" },
  { offset: 12, name: "Pacific/Auckland" },
  { offset: 12, name: "Pacific/Chatham" },
  { offset: 13, name: "Pacific/Tongatapu" },
  { offset: 14, name: "Pacific/Kiritimati" },
];

export const timezones = [
  { label: "Niue Time", value: -11 },
  { label: "Samoa Standard Time", value: -11 },
  { label: "Cook Islands Standard Time", value: -10 },
  { label: "Hawaii-Aleutian Standard Time", value: -10 },
  { label: "Hawaii-Aleutian Time", value: -10 },
  { label: "Tahiti Time", value: -10 },
  { label: "Marquesas Time", value: -9.5 },
  { label: "Alaska Time - Anchorage", value: -9 },
  { label: "Alaska Time - Juneau", value: -9 },
  { label: "Alaska Time - Metlakatla", value: -9 },
  { label: "Alaska Time - Nome", value: -9 },
  { label: "Alaska Time - Sitka", value: -9 },
  { label: "Alaska Time - Yakutat", value: -9 },
  { label: "Gambier Time", value: -9 },
  { label: "Pacific Time - Los Angeles", value: -8 },
  { label: "Pacific Time - Tijuana", value: -8 },
  { label: "Pacific Time - Vancouver", value: -8 },
  { label: "Pitcairn Time", value: -8 },
  { label: "Mexican Pacific Standard Time - Hermosillo", value: -7 },
  { label: "Mexican Pacific Standard Time - Mazatlan", value: -7 },
  { label: "Mountain Standard Time - Dawson Creek", value: -7 },
  { label: "Mountain Standard Time - Fort Nelson", value: -7 },
  { label: "Mountain Standard Time - Phoenix", value: -7 },
  { label: "Mountain Time - Boise", value: -7 },
  { label: "Mountain Time - Cambridge Bay", value: -7 },
  { label: "Mountain Time - Ciudad Juárez", value: -7 },
  { label: "Mountain Time - Denver", value: -7 },
  { label: "Mountain Time - Edmonton", value: -7 },
  { label: "Mountain Time - Inuvik", value: -7 },
  { label: "Yukon Time - Dawson", value: -7 },
  { label: "Yukon Time - Whitehorse", value: -7 },
  { label: "Central Standard Time - Bahía de Banderas", value: -6 },
  { label: "Central Standard Time - Belize", value: -6 },
  { label: "Central Standard Time - Chihuahua", value: -6 },
  { label: "Central Standard Time - Costa Rica", value: -6 },
  { label: "Central Standard Time - El Salvador", value: -6 },
  { label: "Central Standard Time - Guatemala", value: -6 },
  { label: "Central Standard Time - Managua", value: -6 },
  { label: "Central Standard Time - Mérida", value: -6 },
  { label: "Central Standard Time - Mexico City", value: -6 },
  { label: "Central Standard Time - Monterrey", value: -6 },
  { label: "Central Standard Time - Regina", value: -6 },
  { label: "Central Standard Time - Swift Current", value: -6 },
  { label: "Central Standard Time - Tegucigalpa", value: -6 },
  { label: "Central Time - Beulah, North Dakota", value: -6 },
  { label: "Central Time - Center, North Dakota", value: -6 },
  { label: "Central Time - Chicago", value: -6 },
  { label: "Central Time - Knox, Indiana", value: -6 },
  { label: "Central Time - Matamoros", value: -6 },
  { label: "Central Time - Menominee", value: -6 },
  { label: "Central Time - New Salem, North Dakota", value: -6 },
  { label: "Central Time - Ojinaga", value: -6 },
  { label: "Central Time - Rankin Inlet", value: -6 },
  { label: "Central Time - Resolute", value: -6 },
  { label: "Central Time - Winnipeg", value: -6 },
  { label: "Galapagos Time", value: -6 },
  { label: "Acre Standard Time - Eirunepe", value: -5 },
  { label: "Acre Standard Time - Rio Branco", value: -5 },
  { label: "Colombia Standard Time", value: -5 },
  { label: "Cuba Time", value: -5 },
  { label: "Easter Island Time", value: -5 },
  { label: "Eastern Standard Time - Cancún", value: -5 },
  { label: "Eastern Standard Time - Jamaica", value: -5 },
  { label: "Eastern Standard Time - Panama", value: -5 },
  { label: "Eastern Time - Detroit", value: -5 },
  { label: "Eastern Time - Grand Turk", value: -5 },
  { label: "Eastern Time - Indianapolis", value: -5 },
  { label: "Eastern Time - Iqaluit", value: -5 },
  { label: "Eastern Time - Louisville", value: -5 },
  { label: "Eastern Time - Marengo, Indiana", value: -5 },
  { label: "Eastern Time - Monticello, Kentucky", value: -5 },
  { label: "Eastern Time - New York", value: -5 },
  { label: "Eastern Time - Petersburg, Indiana", value: -5 },
  { label: "Eastern Time - Port-au-Prince", value: -5 },
  { label: "Eastern Time - Toronto", value: -5 },
  { label: "Eastern Time - Vevay, Indiana", value: -5 },
  { label: "Eastern Time - Vincennes, Indiana", value: -5 },
  { label: "Eastern Time - Winamac, Indiana", value: -5 },
  { label: "Ecuador Time", value: -5 },
  { label: "Peru Standard Time", value: -5 },
  { label: "Amazon Standard Time - Boa Vista", value: -4 },
  { label: "Amazon Standard Time - Campo Grande", value: -4 },
  { label: "Amazon Standard Time - Cuiaba", value: -4 },
  { label: "Amazon Standard Time - Manaus", value: -4 },
  { label: "Amazon Standard Time - Porto Velho", value: -4 },
  { label: "Atlantic Standard Time - Barbados", value: -4 },
  { label: "Atlantic Standard Time - Martinique", value: -4 },
  { label: "Atlantic Standard Time - Puerto Rico", value: -4 },
  { label: "Atlantic Standard Time - Santo Domingo", value: -4 },
  { label: "Atlantic Time - Bermuda", value: -4 },
  { label: "Atlantic Time - Glace Bay", value: -4 },
  { label: "Atlantic Time - Goose Bay", value: -4 },
  { label: "Atlantic Time - Halifax", value: -4 },
  { label: "Atlantic Time - Moncton", value: -4 },
  { label: "Atlantic Time - Thule", value: -4 },
  { label: "Bolivia Time", value: -4 },
  { label: "Guyana Time", value: -4 },
  { label: "Venezuela Time", value: -4 },
  { label: "Newfoundland Time", value: -3.5 },
  { label: "Argentina Standard Time - Buenos Aires", value: -3 },
  { label: "Argentina Standard Time - Catamarca", value: -3 },
  { label: "Argentina Standard Time - Cordoba", value: -3 },
  { label: "Argentina Standard Time - Jujuy", value: -3 },
  { label: "Argentina Standard Time - La Rioja", value: -3 },
  { label: "Argentina Standard Time - Mendoza", value: -3 },
  { label: "Argentina Standard Time - Rio Gallegos", value: -3 },
  { label: "Argentina Standard Time - Salta", value: -3 },
  { label: "Argentina Standard Time - San Juan", value: -3 },
  { label: "Argentina Standard Time - San Luis", value: -3 },
  { label: "Argentina Standard Time - Tucuman", value: -3 },
  { label: "Argentina Standard Time - Ushuaia", value: -3 },
  { label: "Brasilia Standard Time - Araguaina", value: -3 },
  { label: "Brasilia Standard Time - Bahia", value: -3 },
  { label: "Brasilia Standard Time - Belem", value: -3 },
  { label: "Brasilia Standard Time - Fortaleza", value: -3 },
  { label: "Brasilia Standard Time - Maceio", value: -3 },
  { label: "Brasilia Standard Time - Recife", value: -3 },
  { label: "Brasilia Standard Time - Santarem", value: -3 },
  { label: "Brasilia Standard Time Sao Paulo", value: -3 },
  { label: "Chile Time", value: -3 },
  { label: "Falkland Islands Standard Time", value: -3 },
  { label: "French Guiana Time", value: -3 },
  { label: "Palmer Time", value: -3 },
  { label: "Paraguay Time", value: -3 },
  { label: "Punta Arenas Time", value: -3 },
  { label: "Rothera Time", value: -3 },
  { label: "St. Pierre & Miquelon Time", value: -3 },
  { label: "Suriname Time", value: -3 },
  { label: "Uruguay Standard Time", value: -3 },
  { label: "Fernando de Noronha Standard Time", value: -2 },
  { label: "South Georgia Time", value: -2 },
  { label: "West Greenland Time", value: -2 },
  { label: "Azores Time", value: -1 },
  { label: "Cape Verde Standard Time", value: -1 },
  { label: "East Greenland Time", value: -1 },
  { label: "Coordinated Universal Time", value: 0 },
  { label: "Greenwich Mean Time", value: 0 },
  { label: "Greenwich Mean Time - Abidjan", value: 0 },
  { label: "Greenwich Mean Time - Bissau", value: 0 },
  { label: "Greenwich Mean Time - Danmarkshavn", value: 0 },
  { label: "Greenwich Mean Time - Monrovia", value: 0 },
  { label: "Greenwich Mean Time - Reykjavik", value: 0 },
  { label: "Greenwich Mean Time - São Tomé", value: 0 },
  { label: "Ireland Time", value: 0 },
  { label: "Troll Time", value: 0 },
  { label: "United Kingdom Time", value: 0 },
  { label: "Western European Time - Canary", value: 0 },
  { label: "Western European Time - Faroe", value: 0 },
  { label: "Western European Time - Lisbon", value: 0 },
  { label: "Western European Time - Madeira", value: 0 },
  { label: "Central European Standard Time - Algiers", value: 1 },
  { label: "Central European Standard Time - Tunis", value: 1 },
  { label: "Central European Time - Amsterdam", value: 1 },
  { label: "Central European Time - Andorra", value: 1 },
  { label: "Central European Time - Belgrade", value: 1 },
  { label: "Central European Time - Berlin", value: 1 },
  { label: "Central European Time - Brussels", value: 1 },
  { label: "Central European Time - Budapest", value: 1 },
  { label: "Central European Time - Ceuta", value: 1 },
  { label: "Central European Time - Copenhagen", value: 1 },
  { label: "Central European Time - Gibraltar", value: 1 },
  { label: "Central European Time - Luxembourg", value: 1 },
  { label: "Central European Time - Madrid", value: 1 },
  { label: "Central European Time - Malta", value: 1 },
  { label: "Central European Time - Monaco", value: 1 },
  { label: "Central European Time - Oslo", value: 1 },
  { label: "Central European Time - Paris", value: 1 },
  { label: "Central European Time - Prague", value: 1 },
  { label: "Central European Time - Rome", value: 1 },
  { label: "Central European Time - Stockholm", value: 1 },
  { label: "Central European Time - Tirane", value: 1 },
  { label: "Central European Time - Vienna", value: 1 },
  { label: "Central European Time - Warsaw", value: 1 },
  { label: "Central European Time - Zurich", value: 1 },
  { label: "Morocco Time", value: 1 },
  { label: "West Africa Standard Time - Lagos", value: 1 },
  { label: "West Africa Standard Time - Ndjamena", value: 1 },
  { label: "Western Sahara Time", value: 1 },
  { label: "Central Africa Time - Juba", value: 2 },
  { label: "Central Africa Time - Khartoum", value: 2 },
  { label: "Central Africa Time - Maputo", value: 2 },
  { label: "Central Africa Time - Windhoek", value: 2 },
  { label: "Eastern European Standard Time - Kaliningrad", value: 2 },
  { label: "Eastern European Standard Time - Tripoli", value: 2 },
  { label: "Eastern European Time - Athens", value: 2 },
  { label: "Eastern European Time - Beirut", value: 2 },
  { label: "Eastern European Time - Bucharest", value: 2 },
  { label: "Eastern European Time - Cairo", value: 2 },
  { label: "Eastern European Time - Chisinau", value: 2 },
  { label: "Eastern European Time - Gaza", value: 2 },
  { label: "Eastern European Time - Hebron", value: 2 },
  { label: "Eastern European Time - Helsinki", value: 2 },
  { label: "Eastern European Time - Kyiv", value: 2 },
  { label: "Eastern European Time - Nicosia", value: 2 },
  { label: "Eastern European Time - Riga", value: 2 },
  { label: "Eastern European Time - Sofia", value: 2 },
  { label: "Eastern European Time - Tallinn", value: 2 },
  { label: "Eastern European Time - Vilnius", value: 2 },
  { label: "Famagusta Time", value: 2 },
  { label: "Israel Time", value: 2 },
  { label: "South Africa Standard Time", value: 2 },
  { label: "Arabian Standard Time - Baghdad", value: 3 },
  { label: "Arabian Standard Time - Qatar", value: 3 },
  { label: "Arabian Standard Time - Riyadh", value: 3 },
  { label: "East Africa Time", value: 3 },
  { label: "Jordan Time", value: 3 },
  { label: "Kirov Time", value: 3 },
  { label: "Moscow Standard Time - Minsk", value: 3 },
  { label: "Moscow Standard Time - Moscow", value: 3 },
  { label: "Moscow Standard Time - Simferopol", value: 3 },
  { label: "Syria Time", value: 3 },
  { label: "Türkiye Time", value: 3 },
  { label: "Volgograd Standard Time", value: 3.5 },
  { label: "Iran Standard Time", value: 4 },
  { label: "Armenia Standard Time", value: 4 },
  { label: "Astrakhan Time", value: 4 },
  { label: "Azerbaijan Standard Time", value: 4 },
  { label: "Georgia Standard Time", value: 4 },
  { label: "Gulf Standard Time", value: 4 },
  { label: "Mauritius Standard Time", value: 4 },
  { label: "Réunion Time", value: 4 },
  { label: "Samara Standard Time", value: 4 },
  { label: "Saratov Time", value: 4 },
  { label: "Seychelles Time", value: 4 },
  { label: "Ulyanovsk Time", value: 4 },
  { label: "Afghanistan Time", value: 4.5 },
  { label: "French Southern & Antarctic Time", value: 5 },
  { label: "Maldives Time", value: 5 },
  { label: "Mawson Time", value: 5 },
  { label: "Pakistan Standard Time", value: 5 },
  { label: "Tajikistan Time", value: 5 },
  { label: "Turkmenistan Standard Time", value: 5 },
  { label: "Uzbekistan Standard Time - Samarkand", value: 5 },
  { label: "Uzbekistan Standard Time - Tashkent", value: 5 },
  { label: "Vostok Time", value: 5 },
  { label: "West Kazakhstan Time - Aqtau", value: 5 },
  { label: "West Kazakhstan Time - Aqtobe", value: 5 },
  { label: "West Kazakhstan Time - Atyrau", value: 5 },
  { label: "West Kazakhstan Time - Oral", value: 5 },
  { label: "West Kazakhstan Time - Qyzylorda", value: 5 },
  { label: "Yekaterinburg Standard Time", value: 5 },
  { label: "India Standard Time - Colombo", value: 5.5 },
  { label: "India Standard Time - Kolkata", value: 5.5 },
  { label: "Nepal Time", value: 5.75 },
  { label: "Bangladesh Standard Time", value: 6 },
  { label: "Bhutan Time", value: 6 },
  { label: "East Kazakhstan Time - Almaty", value: 6 },
  { label: "East Kazakhstan Time - Kostanay", value: 6 },
  { label: "Indian Ocean Time", value: 6 },
  { label: "Kyrgyzstan Time", value: 6 },
  { label: "Omsk Standard Time", value: 6 },
  { label: "Urumqi Time", value: 6 },
  { label: "Cocos Islands Time", value: 6.5 },
  { label: "Myanmar Time", value: 6.5 },
  { label: "Barnaul Time", value: 7 },
  { label: "Christmas Island Time", value: 7 },
  { label: "Davis Time", value: 7 },
  { label: "Hovd Standard Time", value: 7 },
  { label: "Indochina Time - Bangkok", value: 7 },
  { label: "Indochina Time - Ho Chi Minh City", value: 7 },
  { label: "Krasnoyarsk Standard Time - Krasnoyarsk", value: 7 },
  { label: "Novosibirsk Standard Time", value: 7 },
  { label: "Tomsk Time", value: 7 },
  { label: "Western Indonesia Time - Jakarta", value: 7 },
  { label: "Western Indonesia Time - Pontianak", value: 7 },
  { label: "Australian Western Standard Time", value: 8 },
  { label: "Brunei Darussalam Time", value: 8 },
  { label: "Casey Time", value: 8 },
  { label: "Central Indonesia Time", value: 8 },
  { label: "China Standard Time - Macao", value: 8 },
  { label: "China Standard Time - Shanghai", value: 8 },
  { label: "Hong Kong Standard Time", value: 8 },
  { label: "Irkutsk Standard Time", value: 8 },
  { label: "Malaysia Time - Kuala Lumpur", value: 8 },
  { label: "Malaysia Time - Kuching", value: 8 },
  { label: "Philippine Standard Time", value: 8 },
  { label: "Singapore Standard Time", value: 8 },
  { label: "Taipei Standard Time", value: 8 },
  { label: "Ulaanbaatar Standard Time - Choibalsan", value: 8 },
  { label: "Ulaanbaatar Standard Time - Ulaanbaatar", value: 8 },
  { label: "Australian Central Western Standard Time", value: 8.75 },
  { label: "East Timor Time", value: 9 },
  { label: "Eastern Indonesia Time", value: 9 },
  { label: "Japan Standard Time", value: 9 },
  { label: "Korean Standard Time - Pyongyang", value: 9 },
  { label: "Korean Standard Time - Seoul", value: 9 },
  { label: "Palau Time", value: 9 },
  { label: "Yakutsk Standard Time - Chita", value: 9 },
  { label: "Yakutsk Standard Time - Khandyga", value: 9 },
  { label: "Yakutsk Standard Time - Yakutsk", value: 9 },
  { label: "Australian Central Standard Time", value: 9.5 },
  { label: "Australian Eastern Standard Time - Brisbane", value: 10 },
  { label: "Australian Eastern Standard Time - Lindeman", value: 10 },
  { label: "Chamorro Standard Time", value: 10 },
  { label: "Chuuk Time", value: 10 },
  { label: "Papua New Guinea Time", value: 10 },
  { label: "Vladivostok Standard Time - Ust-Nera", value: 10 },
  { label: "Vladivostok Standard Time - Vladivostok", value: 10 },
  { label: "Central Australia Time - Adelaide", value: 10.5 },
  { label: "Central Australia Time - Broken Hill", value: 10.5 },
  { label: "Bougainville Time", value: 11 },
  { label: "Eastern Australia Time - Hobart", value: 11 },
  { label: "Eastern Australia Time - Macquarie", value: 11 },
  { label: "Eastern Australia Time - Melbourne", value: 11 },
  { label: "Eastern Australia Time - Sydney", value: 11 },
  { label: "Kosrae Time", value: 11 },
  { label: "Lord Howe Time", value: 11 },
  { label: "Magadan Standard Time", value: 11 },
  { label: "New Caledonia Standard Time", value: 11 },
  { label: "Ponape Time", value: 11 },
  { label: "Sakhalin Standard Time", value: 11 },
  { label: "Solomon Islands Time", value: 11 },
  { label: "Srednekolymsk Time", value: 11 },
  { label: "Vanuatu Standard Time", value: 11 },
  { label: "Anadyr Standard Time", value: 12 },
  { label: "Fiji Standard Time", value: 12 },
  { label: "Gilbert Islands Time", value: 12 },
  { label: "Marshall Islands Time - Kwajalein", value: 12 },
  { label: "Marshall Islands Time - Majuro", value: 12 },
  { label: "Nauru Time", value: 12 },
  { label: "Norfolk Island Time", value: 12 },
  { label: "Petropavlovsk-Kamchatski Standard Time", value: 12 },
  { label: "Tuvalu Time", value: 12 },
  { label: "Wake Island Time", value: 12 },
  { label: "Wallis & Futuna Time", value: 12 },
  { label: "Apia Standard Time", value: 13 },
  { label: "New Zealand Time", value: 13 },
  { label: "Phoenix Islands Time", value: 13 },
  { label: "Tokelau Time", value: 13 },
  { label: "Tonga Standard Time", value: 13 },
  { label: "Chatham Time", value: 13.75 },
  { label: "Line Islands Time", value: 14 },
];


export const timeZones2 =[
  {
      "label": "(GMT-11:00) Niue Time",
      "value": -11
  },
  {
      "label": "(GMT-11:00) Samoa Standard Time",
      "value": -11
  },
  {
      "label": "(GMT-10:00) Cook Islands Standard Time",
      "value": -10
  },
  {
      "label": "(GMT-10:00) Hawaii-Aleutian Standard Time",
      "value": -10
  },
  {
      "label": "(GMT-10:00) Hawaii-Aleutian Time",
      "value": -10
  },
  {
      "label": "(GMT-10:00) Tahiti Time",
      "value": -10
  },
  {
      "label": "(GMT-9.5:00) Marquesas Time",
      "value": -9.5
  },
  {
      "label": "(GMT-9:00) Alaska Time - Anchorage",
      "value": -9
  },
  {
      "label": "(GMT-9:00) Alaska Time - Juneau",
      "value": -9
  },
  {
      "label": "(GMT-9:00) Alaska Time - Metlakatla",
      "value": -9
  },
  {
      "label": "(GMT-9:00) Alaska Time - Nome",
      "value": -9
  },
  {
      "label": "(GMT-9:00) Alaska Time - Sitka",
      "value": -9
  },
  {
      "label": "(GMT-9:00) Alaska Time - Yakutat",
      "value": -9
  },
  {
      "label": "(GMT-9:00) Gambier Time",
      "value": -9
  },
  {
      "label": "(GMT-8:00) Pacific Time - Los Angeles",
      "value": -8
  },
  {
      "label": "(GMT-8:00) Pacific Time - Tijuana",
      "value": -8
  },
  {
      "label": "(GMT-8:00) Pacific Time - Vancouver",
      "value": -8
  },
  {
      "label": "(GMT-8:00) Pitcairn Time",
      "value": -8
  },
  {
      "label": "(GMT-7:00) Mexican Pacific Standard Time - Hermosillo",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mexican Pacific Standard Time - Mazatlan",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Standard Time - Dawson Creek",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Standard Time - Fort Nelson",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Standard Time - Phoenix",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Time - Boise",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Time - Cambridge Bay",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Time - Ciudad Juárez",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Time - Denver",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Time - Edmonton",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Mountain Time - Inuvik",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Yukon Time - Dawson",
      "value": -7
  },
  {
      "label": "(GMT-7:00) Yukon Time - Whitehorse",
      "value": -7
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Bahía de Banderas",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Belize",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Chihuahua",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Costa Rica",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - El Salvador",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Guatemala",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Managua",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Mérida",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Mexico City",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Monterrey",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Regina",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Swift Current",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Standard Time - Tegucigalpa",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Beulah, North Dakota",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Center, North Dakota",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Chicago",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Knox, Indiana",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Matamoros",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Menominee",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - New Salem, North Dakota",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Ojinaga",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Rankin Inlet",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Resolute",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Central Time - Winnipeg",
      "value": -6
  },
  {
      "label": "(GMT-6:00) Galapagos Time",
      "value": -6
  },
  {
      "label": "(GMT-5:00) Acre Standard Time - Eirunepe",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Acre Standard Time - Rio Branco",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Colombia Standard Time",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Cuba Time",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Easter Island Time",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Standard Time - Cancún",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Standard Time - Jamaica",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Standard Time - Panama",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Detroit",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Grand Turk",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Indianapolis",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Iqaluit",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Louisville",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Marengo, Indiana",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Monticello, Kentucky",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - New York",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Petersburg, Indiana",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Port-au-Prince",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Toronto",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Vevay, Indiana",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Vincennes, Indiana",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Eastern Time - Winamac, Indiana",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Ecuador Time",
      "value": -5
  },
  {
      "label": "(GMT-5:00) Peru Standard Time",
      "value": -5
  },
  {
      "label": "(GMT-4:00) Amazon Standard Time - Boa Vista",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Amazon Standard Time - Campo Grande",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Amazon Standard Time - Cuiaba",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Amazon Standard Time - Manaus",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Amazon Standard Time - Porto Velho",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Standard Time - Barbados",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Standard Time - Martinique",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Standard Time - Puerto Rico",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Standard Time - Santo Domingo",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Time - Bermuda",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Time - Glace Bay",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Time - Goose Bay",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Time - Halifax",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Time - Moncton",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Atlantic Time - Thule",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Bolivia Time",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Guyana Time",
      "value": -4
  },
  {
      "label": "(GMT-4:00) Venezuela Time",
      "value": -4
  },
  {
      "label": "(GMT-3.5:00) Newfoundland Time",
      "value": -3.5
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Buenos Aires",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Catamarca",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Cordoba",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Jujuy",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - La Rioja",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Mendoza",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Rio Gallegos",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Salta",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - San Juan",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - San Luis",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Tucuman",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Argentina Standard Time - Ushuaia",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Araguaina",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Bahia",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Belem",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Fortaleza",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Maceio",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Recife",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time - Santarem",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Brasilia Standard Time Sao Paulo",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Chile Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Falkland Islands Standard Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) French Guiana Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Palmer Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Paraguay Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Punta Arenas Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Rothera Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) St. Pierre & Miquelon Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Suriname Time",
      "value": -3
  },
  {
      "label": "(GMT-3:00) Uruguay Standard Time",
      "value": -3
  },
  {
      "label": "(GMT-2:00) Fernando de Noronha Standard Time",
      "value": -2
  },
  {
      "label": "(GMT-2:00) South Georgia Time",
      "value": -2
  },
  {
      "label": "(GMT-2:00) West Greenland Time",
      "value": -2
  },
  {
      "label": "(GMT-1:00) Azores Time",
      "value": -1
  },
  {
      "label": "(GMT-1:00) Cape Verde Standard Time",
      "value": -1
  },
  {
      "label": "(GMT-1:00) East Greenland Time",
      "value": -1
  },
  {
      "label": "(GMT+0:00) Coordinated Universal Time",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time - Abidjan",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time - Bissau",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time - Danmarkshavn",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time - Monrovia",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time - Reykjavik",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Greenwich Mean Time - São Tomé",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Ireland Time",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Troll Time",
      "value": 0
  },
  {
      "label": "(GMT+0:00) United Kingdom Time",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Western European Time - Canary",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Western European Time - Faroe",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Western European Time - Lisbon",
      "value": 0
  },
  {
      "label": "(GMT+0:00) Western European Time - Madeira",
      "value": 0
  },
  {
      "label": "(GMT+1:00) Central European Standard Time - Algiers",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Standard Time - Tunis",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Amsterdam",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Andorra",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Belgrade",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Berlin",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Brussels",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Budapest",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Ceuta",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Copenhagen",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Gibraltar",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Luxembourg",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Madrid",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Malta",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Monaco",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Oslo",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Paris",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Prague",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Rome",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Stockholm",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Tirane",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Vienna",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Warsaw",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Central European Time - Zurich",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Morocco Time",
      "value": 1
  },
  {
      "label": "(GMT+1:00) West Africa Standard Time - Lagos",
      "value": 1
  },
  {
      "label": "(GMT+1:00) West Africa Standard Time - Ndjamena",
      "value": 1
  },
  {
      "label": "(GMT+1:00) Western Sahara Time",
      "value": 1
  },
  {
      "label": "(GMT+2:00) Central Africa Time - Juba",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Central Africa Time - Khartoum",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Central Africa Time - Maputo",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Central Africa Time - Windhoek",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Standard Time - Kaliningrad",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Standard Time - Tripoli",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Athens",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Beirut",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Bucharest",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Cairo",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Chisinau",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Gaza",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Hebron",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Helsinki",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Kyiv",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Nicosia",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Riga",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Sofia",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Tallinn",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Eastern European Time - Vilnius",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Famagusta Time",
      "value": 2
  },
  {
      "label": "(GMT+2:00) Israel Time",
      "value": 2
  },
  {
      "label": "(GMT+2:00) South Africa Standard Time",
      "value": 2
  },
  {
      "label": "(GMT+3:00) Arabian Standard Time - Baghdad",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Arabian Standard Time - Qatar",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Arabian Standard Time - Riyadh",
      "value": 3
  },
  {
      "label": "(GMT+3:00) East Africa Time",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Jordan Time",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Kirov Time",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Moscow Standard Time - Minsk",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Moscow Standard Time - Moscow",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Moscow Standard Time - Simferopol",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Syria Time",
      "value": 3
  },
  {
      "label": "(GMT+3:00) Türkiye Time",
      "value": 3
  },
  {
      "label": "(GMT+3.5:00) Volgograd Standard Time",
      "value": 3.5
  },
  {
      "label": "(GMT+4:00) Iran Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Armenia Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Astrakhan Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Azerbaijan Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Georgia Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Gulf Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Mauritius Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Réunion Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Samara Standard Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Saratov Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Seychelles Time",
      "value": 4
  },
  {
      "label": "(GMT+4:00) Ulyanovsk Time",
      "value": 4
  },
  {
      "label": "(GMT+4.5:00) Afghanistan Time",
      "value": 4.5
  },
  {
      "label": "(GMT+5:00) French Southern & Antarctic Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Maldives Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Mawson Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Pakistan Standard Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Tajikistan Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Turkmenistan Standard Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Uzbekistan Standard Time - Samarkand",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Uzbekistan Standard Time - Tashkent",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Vostok Time",
      "value": 5
  },
  {
      "label": "(GMT+5:00) West Kazakhstan Time - Aqtau",
      "value": 5
  },
  {
      "label": "(GMT+5:00) West Kazakhstan Time - Aqtobe",
      "value": 5
  },
  {
      "label": "(GMT+5:00) West Kazakhstan Time - Atyrau",
      "value": 5
  },
  {
      "label": "(GMT+5:00) West Kazakhstan Time - Oral",
      "value": 5
  },
  {
      "label": "(GMT+5:00) West Kazakhstan Time - Qyzylorda",
      "value": 5
  },
  {
      "label": "(GMT+5:00) Yekaterinburg Standard Time",
      "value": 5
  },
  {
      "label": "(GMT+5.5:00) India Standard Time - Colombo",
      "value": 5.5
  },
  {
      "label": "(GMT+5.5:00) India Standard Time - Kolkata",
      "value": 5.5
  },
  {
      "label": "(GMT+5.75:00) Nepal Time",
      "value": 5.75
  },
  {
      "label": "(GMT+6:00) Bangladesh Standard Time",
      "value": 6
  },
  {
      "label": "(GMT+6:00) Bhutan Time",
      "value": 6
  },
  {
      "label": "(GMT+6:00) East Kazakhstan Time - Almaty",
      "value": 6
  },
  {
      "label": "(GMT+6:00) East Kazakhstan Time - Kostanay",
      "value": 6
  },
  {
      "label": "(GMT+6:00) Indian Ocean Time",
      "value": 6
  },
  {
      "label": "(GMT+6:00) Kyrgyzstan Time",
      "value": 6
  },
  {
      "label": "(GMT+6:00) Omsk Standard Time",
      "value": 6
  },
  {
      "label": "(GMT+6:00) Urumqi Time",
      "value": 6
  },
  {
      "label": "(GMT+6.5:00) Cocos Islands Time",
      "value": 6.5
  },
  {
      "label": "(GMT+6.5:00) Myanmar Time",
      "value": 6.5
  },
  {
      "label": "(GMT+7:00) Barnaul Time",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Christmas Island Time",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Davis Time",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Hovd Standard Time",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Indochina Time - Bangkok",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Indochina Time - Ho Chi Minh City",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Krasnoyarsk Standard Time - Krasnoyarsk",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Novosibirsk Standard Time",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Tomsk Time",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Western Indonesia Time - Jakarta",
      "value": 7
  },
  {
      "label": "(GMT+7:00) Western Indonesia Time - Pontianak",
      "value": 7
  },
  {
      "label": "(GMT+8:00) Australian Western Standard Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Brunei Darussalam Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Casey Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Central Indonesia Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) China Standard Time - Macao",
      "value": 8
  },
  {
      "label": "(GMT+8:00) China Standard Time - Shanghai",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Hong Kong Standard Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Irkutsk Standard Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Malaysia Time - Kuala Lumpur",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Malaysia Time - Kuching",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Philippine Standard Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Singapore Standard Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Taipei Standard Time",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Ulaanbaatar Standard Time - Choibalsan",
      "value": 8
  },
  {
      "label": "(GMT+8:00) Ulaanbaatar Standard Time - Ulaanbaatar",
      "value": 8
  },
  {
      "label": "(GMT+8.75:00) Australian Central Western Standard Time",
      "value": 8.75
  },
  {
      "label": "(GMT+9:00) East Timor Time",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Eastern Indonesia Time",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Japan Standard Time",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Korean Standard Time - Pyongyang",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Korean Standard Time - Seoul",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Palau Time",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Yakutsk Standard Time - Chita",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Yakutsk Standard Time - Khandyga",
      "value": 9
  },
  {
      "label": "(GMT+9:00) Yakutsk Standard Time - Yakutsk",
      "value": 9
  },
  {
      "label": "(GMT+9.5:00) Australian Central Standard Time",
      "value": 9.5
  },
  {
      "label": "(GMT+10:00) Australian Eastern Standard Time - Brisbane",
      "value": 10
  },
  {
      "label": "(GMT+10:00) Australian Eastern Standard Time - Lindeman",
      "value": 10
  },
  {
      "label": "(GMT+10:00) Chamorro Standard Time",
      "value": 10
  },
  {
      "label": "(GMT+10:00) Chuuk Time",
      "value": 10
  },
  {
      "label": "(GMT+10:00) Papua New Guinea Time",
      "value": 10
  },
  {
      "label": "(GMT+10:00) Vladivostok Standard Time - Ust-Nera",
      "value": 10
  },
  {
      "label": "(GMT+10:00) Vladivostok Standard Time - Vladivostok",
      "value": 10
  },
  {
      "label": "(GMT+10.5:00) Central Australia Time - Adelaide",
      "value": 10.5
  },
  {
      "label": "(GMT+10.5:00) Central Australia Time - Broken Hill",
      "value": 10.5
  },
  {
      "label": "(GMT+11:00) Bougainville Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Eastern Australia Time - Hobart",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Eastern Australia Time - Macquarie",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Eastern Australia Time - Melbourne",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Eastern Australia Time - Sydney",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Kosrae Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Lord Howe Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Magadan Standard Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) New Caledonia Standard Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Ponape Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Sakhalin Standard Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Solomon Islands Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Srednekolymsk Time",
      "value": 11
  },
  {
      "label": "(GMT+11:00) Vanuatu Standard Time",
      "value": 11
  },
  {
      "label": "(GMT+12:00) Anadyr Standard Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Fiji Standard Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Gilbert Islands Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Marshall Islands Time - Kwajalein",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Marshall Islands Time - Majuro",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Nauru Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Norfolk Island Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Petropavlovsk-Kamchatski Standard Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Tuvalu Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Wake Island Time",
      "value": 12
  },
  {
      "label": "(GMT+12:00) Wallis & Futuna Time",
      "value": 12
  },
  {
      "label": "(GMT+13:00) Apia Standard Time",
      "value": 13
  },
  {
      "label": "(GMT+13:00) New Zealand Time",
      "value": 13
  },
  {
      "label": "(GMT+13:00) Phoenix Islands Time",
      "value": 13
  },
  {
      "label": "(GMT+13:00) Tokelau Time",
      "value": 13
  },
  {
      "label": "(GMT+13:00) Tonga Standard Time",
      "value": 13
  },
  {
      "label": "(GMT+13.75:00) Chatham Time",
      "value": 13.75
  },
  {
      "label": "(GMT+14:00) Line Islands Time",
      "value": 14
  }
]